<template>
  <div class="login-home-page">
    <div
        style="padding: 8px; background-color: rgb(238, 236, 237); width: 100%; display: flex; align-items: center; justify-content: center;">
      <img :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'" alt="" style="width: 30%;"></div>

    <swiper class=" my-swipe"   :options="bannerSwiperOption">
      <swiper-slide v-for="(v,key) in swipe" :key="key">
        <img :src="v" alt="" style="width: 100%;">
      </swiper-slide>
    </swiper>

    <div style="padding: 1rem;">
      <div><h2 style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin: 5px; text-align: center;">
        <a href="#/login"><span style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >파티 상품</strong></span></a></h2></div>
      <div style="height: 0.3rem;"></div>
      <div class="img-scroller" ref="scrollList1">
        <div class="img-container"><img src="img/s2.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}26,820</span></div>
        <div class="img-container"><img src="img/s3.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}31,320</span></div>
        <div class="img-container"><img src="img/s4.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}35,820</span></div>
        <div class="img-container"><img src="img/s5.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}38,520</span></div>
        <div class="img-container"><img src="img/s6.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}42,120</span></div>
        <div class="img-container"><img src="img/s7.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}44,820</span></div>
      </div>
      <div style="height: 1rem;"></div>
      <div class="img-scroller" ref="scrollList2">
        <div class="img-container"><img src="img/s8.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}28,620</span></div>
        <div class="img-container"><img src="img/s9.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}32,220</span></div>
        <div class="img-container"><img src="img/s10.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}34,920</span></div>
        <div class="img-container"><img src="img/s11.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}37,620</span></div>
        <div class="img-container"><img src="img/s12.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}40,320</span></div>
        <div class="img-container"><img src="img/s13.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}43,020</span></div>
        <div class="img-container"><img src="img/s14.jpg" alt=""><span
            class="price-tag">{{ $store.getters.getBaseInfo.currency }}44,820</span></div>
      </div>
      <div style="height: 1rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >쿠폰 대상 인기 아이템</strong></span></a></h2></div>
      <div>

        <div class="item-scroll-list">
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 1</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt1.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">20%쿠폰 지오다노 BEST 신상/이월 특가전 ~ 67%OFF
                      반팔티/반바지/카라티 외
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}15,200</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}63,300
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 2</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt2.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">30%+20%) 르샵/위시드 지금 데일리로 딱 입기 좋은 여름 인기 아이템
                      100종 특가 (무료반품)
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}13,950</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}93,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 3</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt3.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">혜택가 209만원대 LG 휘센 오브제컬렉션 타워II FQ17ET1HC2
                      기본설치포함
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}2,204,990
                        </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}2,791,660
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 4</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt4.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">((20%쿠폰)) 피핀 여름신상 인기급상승
                      판매1위/티셔츠/원피스/팬츠/데님/빅사이즈/자체제작
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}13,930</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}66,330
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 5</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt5.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(패션픽)푸마 남녀공용 에어드라이 반팔반바지 1종 택일</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}9,900 </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}44,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 6</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt6.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">공식인증점 인버터 벽걸이 에어컨 26.4㎡ OARB-0081FAWSD
                      기본설치비무료 일반배관
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}536,540
                        </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}631,230
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 7</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt7.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">게토레이 이온음료 레몬 600ml x 20pet 이온음료 / 스포츠 음료 /
                      레몬 음료 / 대용량 음료 / 청량음료
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}22,100</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}28,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 8</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt8.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(패션픽)(30%+사은품) 5000원대부터~로즈맘 여름신상/BEST 초특가
                      할인/5060중년여성/엄마옷/티셔츠바지
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}10,010</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}47,660
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 9</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt9.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(1+1행사)(NEW)불스원샷 플래티넘 연료첨가제 5in1 500ML
                      2종택1(휘발유 경유)
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}28,810</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}50,900
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 10</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt10.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(패션픽)(20%) 9730원~ 저스트원
                      신상/셔츠/슬랙스/청바지/일자/긴팔/반팔/조끼/니트
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}14,760</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}61,500
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 11</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt11.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(10%캐시적립) 한율 쑥떡팩폼 클렌징 120ml+15ml +어린쑥 클렌징
                      팩밤 15g+마스크팩 2장
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}19,600</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}28,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 12</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt12.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">려 흑운 모근강화볼륨케어 샴푸 550ml 3개</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}20,700</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}29,200
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 13</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt13.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(1+1행사)뉴 크리스탈코트 플러스 유리막코팅제
                      500ml(광택+발수코팅효과)
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}20,900</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}30,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 14</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt14.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">키즈 스텝1 사과향 3박스(3개월분) + 키즈 스텝1 10일분 증정 + 10%
                      적립
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}140,400
                        </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}234,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 15</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt15.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">하이뮨 프로틴 밸런스 액티브 딥초코 ZERO 2박스(250ml
                      총36입)+10%적립
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}50,000</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}66,680
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 16</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt16.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">삼성 비스포크 냉장고 1등급 4도어 RF90DG91114E 902L
                      푸드쇼케이스 902리터 대용량 헤택가153만원대
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}1,609,000
                        </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}1,943,240
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 17</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt17.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">모나리자 소프트리 미용티슈 230매 6입 2개 총12개 눈금창 각티슈
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}14,880</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}30,300
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 18</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt18.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">캐리어 1등급 20L 제습기 CDHC-200AXLWLYH</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}283,000
                        </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}337,760
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 19</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt19.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(신선집중) 농협안심한우 제주한우 1++(9)등급 한우 등심 200g /
                      근내지방도 최고등급 마블링 넘버9 한우
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}16,800</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}27,500
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 20</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt20.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">NEW 업그레이드 하이뮨 프로틴 밸런스 2캔
                      +스틱2박스(20입)+보틀+10%적립
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}35,000</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}46,680
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 21</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt21.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">통살새우까스 1kg(20개입)/쿠폰가 15520원</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}15,520</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}19,400
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 22</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt22.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">피톤치드 편백수 탈취제 500ml+2L 사은품 새집증후군집들이 차량/실내탈취
                      확실한 탈취효과 디퓨저 행사
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}16,800</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}56,400
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 23</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt23.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(패션픽)(20%+이벤트1+1) 6960~데이뮤즈 빅사이즈/미시의류/홈쇼핑
                      티셔츠/가디건/원피스/블라우스/팬츠
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}8,960 </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}37,330
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 24</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt24.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">베이비 스텝1 3박스(3개월분) + 베이비스텝2 10일분 증정 + 10%
                      적립
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}68,900</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}106,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 25</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt25.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">휴비스 듀라론 100% 대한민국 수면공작소 냉감패드 베개커버 3중직 KC
                      오코텍스 S SS Q K LK XK 풀사이즈
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}16,800</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}39,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 26</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt26.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">LG전자 트롬 워시타워 W20WD 세탁24kg 건조20kg</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}2,418,180
                        </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}3,103,750
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 27</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt27.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(~50%) 이니스프리
                      선크림/클렌징/메이크업/마스크/레티놀/PDRN/비타C/그린티/블랙티/노세범/화산송이
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}23,620</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}105,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 28</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt28.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(타임특가)(1+1) 맥퀸뉴욕 삼지창
                      눈썹타투펜/워터프루프/눈썹펜슬/립스틱/립글로스/선크림/앰플/패드/세럼
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}8,920 </div>
                      <div class="global-primary dark-primary price sl-price price-crossed">{{ $store.getters.getBaseInfo.currency }}21,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">인기 상품 29</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pdt29.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">(20+10%) 밀레 본사 반팔티셔츠/반바지/냉감티/바람막이/등산바지 SS
                      BEST추천
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price">{{ $store.getters.getBaseInfo.currency }}27,300</div>
                      <div class="global-primary dark-primary price sl-price price-crossed">
                        {{ $store.getters.getBaseInfo.currency }}129,000
                      </div>
                    </div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </div>
        <div class="dots-container">
          <div class="dot"></div>
          <div class="dot active"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div style="height: 1rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >체크한 아이템</strong></span></a></h2></div>
      <div>
        <div class="item-scroll-list">
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">여성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb1.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">팝업 이벤트 판매품 스트로 &amp; 가죽 쇼핑백 스몰 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}1,602,216
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">여성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb2.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">팝업 이벤트 판매품 스트로 &amp; 가죽 쇼핑백 스몰 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}1,602,216
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">여성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb3.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">팝업 이벤트 판매품 스트로 &amp; 가죽 쇼핑백 미디엄 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}1,769,768
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb4.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">패브릭 &amp; 가죽 백팩 미디엄 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}2,335,256
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb5.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">토즈 Di 백 가죽 크로스바디 백 미니 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}1,288,056
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb6.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">토즈 Di 백 가죽 브리프케이스 미디엄 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,549,208
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb7.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">토즈 Di 백 가죽 브리프케이스 미디엄 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,549,208
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb8.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">토즈 가죽 DI 백 라지 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}4,672,512
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb9.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">곤미니 가죽 드라이빙 슈즈 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}1,078,616
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb10.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 시그니처 로퍼 #180 배송 10개월 무료배송
                      매장수령 가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,141,600
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb11.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 시그니처 로퍼 #180 배송 10개월 무료배송
                      매장수령 가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,141,600
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb12.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 골프 더비 #641 배송 10개월 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,457,560
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb13.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 골프 더비 #641 배송 10개월 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,457,560
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb14.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 시그니처 로퍼 #180 (슈트리 세트) 배송
                      10개월 무료배송 매장수령 가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,352,960
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb15.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 시그니처 로퍼 #180 (슈트리 세트) 배송
                      10개월 무료배송 매장수령 가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,352,960
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb16.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">J.M. WESTON 남성 골프 더비 #641 (슈트리 세트) 배송 10개월
                      무료배송 매장수령 가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,667,600
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="data:image/jpeg;base64,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"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 Re-Nylon x 사피아노 가죽 벨트백 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}2,303,840
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb18.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 Re-Nylon x 사피아노 가죽 백팩 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}5,602,520
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb19.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 사피아노 가죽 숄더백 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}4,188,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb20.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 사피아노 가죽 숄더백 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,717,560
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb21.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 비텔로다이노 가죽 숄더백 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,300,680
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb22.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 Re-Nylon x 사피아노 가죽 백팩 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,508,120
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb23.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 가죽 토트백 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}4,451,600
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb24.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 프라다 브릭 사피아노 가죽 백 무료배송 매장수령 가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,508,120
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb25.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 Re-Nylon x 사피아노 가죽 숄더백 무료배송 매장수령
                      가능
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,352,960
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb26.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 비텔로다이노 가죽 숄더백 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}4,087,080
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb27.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 사피아노 가죽 파우치 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,247,320
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb28.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">PRADA 남성 사피아노 가죽 벨트백 무료배송 매장수령 가능</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}3,193,960
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb29.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">BVLGARI 옥토 로마 시계</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}14,560,080
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb30.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">BREGUET 클래식 수스크립션 2025</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}70,052,880
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb31.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">BREITLING 탑타임 B01 파우스토 코피</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}10,832,520
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">여성 남성</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/bb32.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">A. LANGE &amp; SOHNE 랑에1</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}58,200,600
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </div>
        <div class="dots-container">
          <div class="dot"></div>
          <div class="dot active"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div style="height: 1rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >카테고리에서 검색</strong></span></a></h2></div>
      <div
          style="display:grid;grid-template-columns:repeat(4,1fr);grid-column-gap:8px;grid-row-gap:8px;padding:1rem;box-sizing:border-box;">
        <div class="category-tag"><img alt="" src="img/f1.png">
          <div> 미식・식품</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f2.png">
          <div> 가전제품</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f3.png">
          <div> 여성 패션</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f4.png">
          <div> 가방・지갑・패션 소품</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f5.png">
          <div> 남성 패션</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f6.png">
          <div> 스포츠・아웃도어</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f7.png">
          <div> 디저트・과자</div>
        </div>
        <div class="category-tag"><img alt="" src="img/f8.png">
          <div> 뷰티・코스메틱</div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;"><img
          style="height:120px;" alt="" src="img/f9.png"> 럭셔리
      </div>
      <div style="height:1rem;"></div>
      <div style="height:1rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >24시간 타임 세일</strong></span></a></h2></div>
      <div>
        <div class="item-scroll-list">
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">24시간</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss1.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">전색상 매진! 날씬해 보이는 컷소우</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}12,186
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss2.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">클릭한 분 한정 가격! cocone 클레이 크림 샴푸</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}33,929
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">세일</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss3.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">반값★ 텁텁함 제로 혁명! 진함 100%! 상위 10% 희소 루이보스♪
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}13,233
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss4.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">【20000mAh 경량】 모바일 배터리 5대 동시 충전 LED 잔량 표시
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}19,973
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">세일</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss5.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">쿠폰 적용 1,878엔! 5Way &amp; 양산 최강 조합~ 클립 팬
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}25,495
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">60% 할인</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss6.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">60% 할인 쿠폰 적용 2,432엔! 여름 대비★ 선풍기 24시간 타임세일
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}57,922
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss7.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">1식 60엔! 아침 대용★ 슈퍼 죽 6종 18식 구성♪</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}10,282
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">반값</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss8.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">반값! 1,980엔 선택형 2타입 맥시 원피스</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}18,850
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">쿠폰</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss9.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">【쿠폰 적용 1,000엔!】 라쿠텐 1위 11관왕★ 하루 종일 무너지지 않는
                      파운데이션
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}18,850
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss10.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">진드기 방지 &amp; 항균 효과! 상쾌한 향 젤볼 세제 30개 리필!
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}9,520
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">최신</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/ss11.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">최신 모델 강풍량・윤기 모발・빠른 건조・과열 보호</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}34,082
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </div>
        <div class="dots-container">
          <div class="dot"></div>
          <div class="dot active"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div style="height: 1rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >고향 납세 인기 반례품</strong></span></a></h2></div>
      <div>
        <div class="item-scroll-list">
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp1.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">맛있는 찰옥수수 냉동 옥수수 10개, 옥수수중</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}13,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp2.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">입점특가 100% 국산 전라도 배추 겉절이, 1개, 2kg</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}21,950
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp3.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">손질된 순살 먹태채 대용량 업소용, 1개, 500g</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}22,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp4.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">[경북 고산지] 초특가 꿀 사과 햇 부사사과 가정용, 1박스, 꿀 사과
                      4kg(중과)
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}28,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp5.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">비브르 LED 바디트리머 제모면도기 셀프왁싱 가정용, 블랙그레이</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}44,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp6.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">로열스테디 자국없는 초강력 양면테이프, 2개</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp7.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">[EEE] 파손보장 무항생제 맥반석 구운계란 15구 30구 달걀 훈제란 구운란
                      부활절계란, 중란, 1개
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}8,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp8.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">특가진행중 딱2주한정특가 천상의맛 신비복숭아 신선복숭아, 1박스,
                      신선1kg(중소과)
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}12,940
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp9.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">한상궁김치 겉절이 2kg, 1개</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}20,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp10.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">20brix 꿀흠벅 최고급특수품종 가정용 사과, 1세트,
                      옵션1-(소과)1.5kg내외
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}10,830
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"><span
                      class="product-customized-labels-content">고향</span></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pp11.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">쫀득한 냉동 홍찰 옥수수 13cm~15cm, 1개, 쫀득 찰옥수수 15개
                      2.4kg
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}17,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </div>
        <div class="dots-container">
          <div class="dot"></div>
          <div class="dot active"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div style="height: 1rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >가게에서 강추 상품</strong></span></a></h2></div>
      <div>
        <div class="item-scroll-list">
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk1.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">거울시트지 욕실거울 녹 테두리 리폼 일자라인, 그레이</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}15,610
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk2.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">로랜텍 플라이 해충 퇴치 파스텔 전기 모기 파리채, 화이트</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}9,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk3.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">타르트생지 에그타르트 만들기 세트 22gX30개입+에그크림1L 간식 페스츄리
                      파이, 페스츄리 타르트 쉘(30ea) + 에그크림(1kg), 1kg, 1개
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}22,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk4.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">다루마 9-in1 스팀청소기 DSC-1200</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}124,000
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk5.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">Tiger Pavilion 스테인리스 스틸 논스틱 편수냄비, 1개, 20cm,
                      실버
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}13,510
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk6.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">Tiger Pavilion 롱 테이프 클리너 + 리필 3개입 세트, 1개
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}5,990
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk7.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">FECBK 손잡이 차량용 스트로우 스테인리스 스틸 텀블러 + 뚜껑 2개입,
                      1개, 화이트, 1200ml
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}9,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk8.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">탄씨엔쯔 탄스트라이더 TXZ-CAB3029 휴대용 스틸체어
                      폴딩캠핑의자+보관가방 세트, 블랙, 1개
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}9,400
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk9.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">Tiger Pavilion 세라믹 에나멜 수프 팟, 1개, 28cm, 블랙
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}10,990
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/pk10.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">BLACKDOG 6.8m 마운틴 퀵 캐빈 텐트 330x220x185cm
                      CBD2450WS050, 나이트 블랙, 4-6인용
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}125,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </div>
        <div class="dots-container">
          <div class="dot"></div>
          <div class="dot active"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div style="height: 2rem;"></div>
      <div><h2
                                  style="background-color: rgb(230, 41, 120); padding: 10px; border-radius: 8px; margin-bottom: 5px; text-align: center;">
        <a href="#/login"><span
                                                   style="font-size: 1.2rem; color: rgb(255, 255, 255);"><strong
           >HOT! TREND</strong></span></a></h2></div>
    </div>

    <swiper class="van-swipe"   :options="bannerSwiperOption">
      <swiper-slide v-for="(v,key) in swipe1" :key="key">
        <img :src="v" alt="" style="width: 100%;">
      </swiper-slide>
    </swiper>

    <div style="padding: 0px 1rem;">
      <div>
        <div class="item-scroll-list">
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd1.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">플랜디 데일리 바캉스 바스락 햇빛차단 턱끈 버킷햇</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}12,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd2.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">엘블로썸 여성 투버튼 롱 와이드 청바지 [사이드 리벳 포인트]</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}19,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd3.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">팀스핏(품질보증) 남성용 30~38 세미 와이드 청바지 프리미엄 코튼 데님팬츠
                      빅사이즈할인
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}39,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="data:image/jpeg;base64,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"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">SHOPPI 리얼 소가죽 여성 데일리 백팩 캐쥬얼 배낭쿠폰할인</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}64,700
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd5.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">맨즈셀렉터 남자 카고 반바지</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}21,800
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd6.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">[담앤드솜 2세대 심플 미니 힙색] 허리 어깨 방수 스포츠 운동 조깅 가슴
                      남자 돈 웨이스트 메신저 크로스 슬링백 러닝 허리쌕 가방 지갑 파우치 쌕 소형 작은 등산 자전거
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}17,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="data:image/jpeg;base64,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"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">베이직바이블 쿨링 아이스 투턱 와이드 조거 스트링 밴딩 스판 슬랙스
                      팬츠(4color)
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}27,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd8.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">[2PACK/AS가능] 지프 JEEP 반팔 티셔츠 남녀공용 반팔티 오버핏
                      레이어드 커플
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}39,500
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd9.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">제로투히어로 남성용 헬스 버뮤다 팬츠</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}29,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd10.png"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">썬리즈 얼굴 햇빛 가리개 자외선 차단 마스크 1+1할인</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}12,500
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd11.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">지티스 기내용 아동용 목베개, 차콜쿨링</div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}25,300
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
          <div class="owl-item" style="width: 50%; margin-right: 16px;">
            <div>
              <div class="product-item"><a href="#/login"
                                                              class="quick-cart-item js-quick-cart-item ng-isolate-scope">
                <div class="boxify-image-wrapper js-quick-boxify-image multi-image">
                  <div class="product-customized-labels primary-bg-color-tag"></div>
                  <div class="boxify-image js-boxify-image center-contain sl-media">
                    <div class="boxify-image-wrap"><img alt=""
                                                                           src="img/hotpd12.jpg"
                                                                           class="lazyautosizes ls-is-cached sl-lazyloaded">
                    </div>
                  </div>
                </div>
                <div class="info-box --plp-variant-image-circle">
                  <div class="info-box-inner-wrapper">
                    <div class="title text-primary-color">팀스핏 남성용 M~4XL 빅사이즈 사계절 정장수트 자켓 정장바지 세트
                      결혼식정장
                    </div>
                    <div class="quick-cart-price">
                      <div class="price-sale price sl-price primary-color-price no-max">{{ $store.getters.getBaseInfo.currency }}121,900
                        </div></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </div>
        <div class="dots-container">
          <div class="dot"></div>
          <div class="dot active"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </div>
    <div style="height:20px;"></div>
    <div style="background-color:#EEECED;padding:30px;box-sizing:border-box;width:100%;">
      <div
          style="display:grid;grid-template-columns:repeat(2,1fr);grid-column-gap:42px;grid-row-gap:42px;box-sizing:border-box;padding:12px;">
        <img src="img/footer1.png" alt="" style="width:100%;"><img src="img/footer2.png" alt=""
                                                                            style="width:100%;"><img
          src="img/footer3.png" alt="" style="width:100%;"><img src="img/footer4.png" alt=""
                                                                         style="width:100%;"></div>
    </div>
    <div style="background-color:#EEECED;padding:30px;box-sizing:border-box;width:100%;border-top:1px solid #ccc;">
      <div id="footer-custom-padding">
        <div class="footer-grid-items">
          <div class="footer-grid-item"><p class="text-title">｜쇼핑 정보｜</p>
            <p><a href="#/login">❤️ {{ this.$store.getters.getBaseInfo.name }} 클럽에 대하여</a></p>
            <p><a href="#/login">이용 약관</a></p>
            <p><a href="#/login">개인정보 처리방침</a></p>
            <p><a href="#/login">판매 대리 신청</a></p>
            <p><a href="#/login">매장 정보</a></p></div>
          <div class="footer-grid-item"><p class="text-title">｜쇼핑 가이드｜</p>
            <p><a href="#/login">배송 및 결제</a><br><a href="#/login">반품・교환 안내</a></p>
            <p><a href="#/login">제품 책임 보험</a></p>
            <p><a href="#/login">사기 방지 안내</a></p>
            <p><a href="#/login">자주 묻는 질문</a></p></div>
          <div class="footer-grid-item">
            <div class="footer-social-icon-wrapper"><a href="#/login">
              <svg class="icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.146 12.073C24.146 5.40365 18.7424 0 12.073 0C5.40365 0 0 5.40365 0 12.073C0 18.0988 4.41493 23.0935 10.1866 24V15.563H7.11968V12.073H10.1866V9.41306C10.1866 6.38751 11.9878 4.71627 14.7466 4.71627C16.0678 4.71627 17.4494 4.95189 17.4494 4.95189V7.92146H15.9267C14.4273 7.92146 13.9594 8.85225 13.9594 9.8069V12.073H17.3077L16.7723 15.563H13.9594V24C19.7311 23.0935 24.146 18.0988 24.146 12.073Z"
                    fill="#333333"></path>
              </svg>
            </a><a href="#/login">
              <svg class="icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4527_91515)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.39661 0.0436591C5.68114 0.0200558 7.14491 0.0148926 12.1499 0.0148926H16.0518C18.8638 0.0197783 19.0238 0.0429532 19.558 0.120312L19.589 0.124795C20.745 0.291493 21.7149 0.752495 22.5079 1.51001C22.9523 1.93764 23.2584 2.35586 23.5341 2.91588C23.87 3.60001 24.0351 4.24725 24.1107 5.20982C24.1269 5.41635 24.1343 8.70311 24.1343 11.9921C24.1343 15.2805 24.1275 18.5733 24.1112 18.7799C24.0366 19.7271 23.8715 20.3799 23.546 21.0511C23.2283 21.709 22.7708 22.2896 22.2055 22.7524C21.6402 23.2152 20.9806 23.549 20.2729 23.7305C19.752 23.8651 19.2809 23.9283 18.4695 23.9665C18.18 23.9812 15.1521 23.9849 12.1243 23.9849C9.09642 23.9849 6.07041 23.9757 5.77353 23.9628C5.07281 23.9296 4.52698 23.8595 4.03279 23.7323C2.60553 23.3635 1.39402 22.3751 0.75968 21.0585C0.427759 20.3707 0.271019 19.7419 0.188038 18.7424C0.164066 18.4584 0.158534 16.9962 0.158534 11.9952C0.158534 11.3825 0.158291 10.8265 0.158069 10.321C0.157681 9.43662 0.157361 8.70711 0.158534 8.09975C0.163248 5.28463 0.186142 5.12668 0.264016 4.58944C0.26535 4.58024 0.266701 4.57092 0.268068 4.56147C0.434951 3.40676 0.895952 2.43533 1.6566 1.64573C2.07427 1.21276 2.49747 0.903888 3.03408 0.637429C3.73037 0.290756 4.3695 0.129037 5.39661 0.0436591ZM8.4946 3.20338C9.43874 3.16041 9.74041 3.1499 12.1443 3.1499H12.1417C14.5463 3.1499 14.8468 3.16041 15.791 3.20338C16.7333 3.24653 17.3768 3.39571 17.9411 3.61459C18.5238 3.84048 19.0161 4.1429 19.5085 4.63525C20.0008 5.12723 20.3032 5.62105 20.5301 6.20321C20.7477 6.766 20.897 7.40918 20.9413 8.35147C20.9837 9.2956 20.9947 9.59728 20.9947 12.0011C20.9947 14.405 20.9837 14.7059 20.9413 15.65C20.897 16.592 20.7477 17.2353 20.5301 17.7983C20.3032 18.3803 20.0008 18.8741 19.5085 19.3661C19.0167 19.8584 18.5236 20.1616 17.9416 20.3877C17.3785 20.6065 16.7345 20.7557 15.7923 20.7989C14.8481 20.8418 14.5474 20.8524 12.1433 20.8524C9.73968 20.8524 9.43818 20.8418 8.49405 20.7989C7.55195 20.7557 6.90858 20.6065 6.34542 20.3877C5.76363 20.1616 5.26981 19.8584 4.77801 19.3661C4.28585 18.8741 3.98343 18.3803 3.75717 17.7981C3.53847 17.2353 3.38929 16.5921 3.34596 15.6499C3.30318 14.7057 3.29248 14.405 3.29248 12.0011C3.29248 9.59728 3.30354 9.29542 3.34559 8.35129C3.388 7.40937 3.53736 6.766 3.7568 6.20302C3.98361 5.62105 4.28603 5.12723 4.77838 4.63525C5.27036 4.14308 5.76419 3.84067 6.34634 3.61459C6.90913 3.39571 7.55232 3.24653 8.4946 3.20338ZM11.8493 4.74488C11.6703 4.7448 11.5044 4.74473 11.3502 4.74497V4.74275C9.70058 4.7446 9.38415 4.75566 8.56763 4.79254C7.70463 4.83219 7.23607 4.97602 6.92407 5.09772C6.51101 5.25852 6.21597 5.4503 5.90617 5.76009C5.59638 6.06988 5.40424 6.36492 5.24381 6.77798C5.12266 7.08999 4.97846 7.55837 4.93899 8.42136C4.89658 9.35443 4.8881 9.63324 4.8881 11.9969C4.8881 14.3605 4.89658 14.6408 4.93899 15.5739C4.97827 16.4369 5.12266 16.9053 5.24381 17.2169C5.4046 17.6301 5.59638 17.9244 5.90617 18.2342C6.21597 18.544 6.51101 18.7358 6.92407 18.8962C7.23626 19.0174 7.70463 19.1616 8.56763 19.2014C9.50069 19.2438 9.7808 19.253 12.1443 19.253C14.5075 19.253 14.7878 19.2438 15.7209 19.2014C16.5839 19.162 17.0526 19.0181 17.3643 18.8964C17.7775 18.736 18.0716 18.5442 18.3814 18.2344C18.6912 17.9248 18.8834 17.6307 19.0438 17.2176C19.1649 16.906 19.3091 16.4376 19.3486 15.5746C19.391 14.6416 19.4002 14.3613 19.4002 11.9991C19.4002 9.63693 19.391 9.35664 19.3486 8.42357C19.3093 7.56058 19.1649 7.0922 19.0438 6.78056C18.883 6.36751 18.6912 6.07247 18.3814 5.76267C18.0718 5.45288 17.7773 5.2611 17.3643 5.10068C17.0523 4.97952 16.5839 4.83532 15.7209 4.79586C14.7876 4.75345 14.5075 4.74497 12.1443 4.74497C12.0421 4.74497 11.9439 4.74492 11.8493 4.74488ZM16.2788 6.39367C16.4535 6.27694 16.6589 6.21464 16.869 6.21464V6.21427C17.4554 6.21427 17.9311 6.69002 17.9311 7.27642C17.9312 7.48651 17.869 7.6919 17.7523 7.86661C17.6356 8.04133 17.4698 8.17753 17.2757 8.25798C17.0816 8.33842 16.868 8.35951 16.662 8.31857C16.4559 8.27763 16.2666 8.1765 16.1181 8.02797C15.9695 7.87944 15.8683 7.69018 15.8273 7.48414C15.7862 7.27809 15.8073 7.06451 15.8876 6.8704C15.968 6.6763 16.1042 6.51039 16.2788 6.39367ZM7.59879 12.0011C7.59879 9.49094 9.63391 7.45575 12.1441 7.45565C14.6543 7.45565 16.6892 9.49088 16.6892 12.0011C16.6892 14.5114 14.6545 16.5457 12.1443 16.5457C9.63402 16.5457 7.59879 14.5114 7.59879 12.0011ZM15.0947 12.0011C15.0947 10.3716 13.7736 9.05072 12.1443 9.05072C10.5147 9.05072 9.19385 10.3716 9.19385 12.0011C9.19385 13.6305 10.5147 14.9515 12.1443 14.9515C13.7736 14.9515 15.0947 13.6305 15.0947 12.0011Z"
                        fill="#333333"></path>
                </g>
                <defs>
                  <clipPath id="clip0_4527_91515">
                    <rect width="24" height="24" fill="white" transform="translate(0.145996)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </a><a href="#/login">
              <svg class="icon" width="25" height="24" viewBox="0 0 25 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.7228 9.225V13.0339C14.7228 13.1304 14.6478 13.2054 14.5514 13.2054H13.9406C13.8817 13.2054 13.8281 13.1732 13.8014 13.1357L12.0549 10.7786V13.0393C12.0549 13.1357 11.9799 13.2107 11.8835 13.2107H11.2728C11.1764 13.2107 11.1014 13.1357 11.1014 13.0393V9.23036C11.1014 9.13393 11.1764 9.05893 11.2728 9.05893H11.8781C11.9317 9.05893 11.9906 9.08572 12.0174 9.13393L13.7639 11.4911V9.23036C13.7639 9.13393 13.8389 9.05893 13.9353 9.05893H14.546C14.6424 9.05357 14.7228 9.13393 14.7228 9.225V9.225ZM10.3299 9.05357H9.71921C9.62278 9.05357 9.54778 9.12857 9.54778 9.225V13.0339C9.54778 13.1304 9.62278 13.2054 9.71921 13.2054H10.3299C10.4264 13.2054 10.5014 13.1304 10.5014 13.0339V9.225C10.5014 9.13393 10.4264 9.05357 10.3299 9.05357V9.05357ZM8.85671 12.2464H7.19064V9.225C7.19064 9.12857 7.11564 9.05357 7.01922 9.05357H6.4085C6.31207 9.05357 6.23707 9.12857 6.23707 9.225V13.0339C6.23707 13.0821 6.25314 13.1196 6.28529 13.1518C6.31743 13.1786 6.35493 13.2 6.40314 13.2H8.85136C8.94778 13.2 9.02278 13.125 9.02278 13.0286V12.4179C9.02278 12.3268 8.94779 12.2464 8.85671 12.2464V12.2464ZM17.9371 9.05357H15.4888C15.3978 9.05357 15.3174 9.12857 15.3174 9.225V13.0339C15.3174 13.125 15.3924 13.2054 15.4888 13.2054H17.9371C18.0335 13.2054 18.1085 13.1304 18.1085 13.0339V12.4232C18.1085 12.3268 18.0335 12.2518 17.9371 12.2518H16.271V11.6089H17.9371C18.0335 11.6089 18.1085 11.5339 18.1085 11.4375V10.8214C18.1085 10.725 18.0335 10.65 17.9371 10.65H16.271V10.0071H17.9371C18.0335 10.0071 18.1085 9.93215 18.1085 9.83572V9.225C18.1031 9.13393 18.0281 9.05357 17.9371 9.05357V9.05357ZM24.146 4.37679V19.6607C24.1406 22.0607 22.1746 24.0053 19.7692 24H4.48529C2.08529 23.9946 0.14065 22.0232 0.146007 19.6232V4.33929C0.151364 1.93929 2.12279 -0.0053461 4.52279 1.10419e-05H19.8067C22.2067 0.00536818 24.1513 1.97144 24.146 4.37679ZM20.846 10.9446C20.846 7.03393 16.9246 3.85179 12.1085 3.85179C7.29243 3.85179 3.371 7.03393 3.371 10.9446C3.371 14.4482 6.47814 17.3839 10.6781 17.9411C11.7014 18.1607 11.5835 18.5357 11.3531 19.9125C11.3156 20.1321 11.1764 20.775 12.1085 20.3839C13.0406 19.9928 17.1388 17.4214 18.9763 15.3107C20.2406 13.9179 20.846 12.5089 20.846 10.9446Z"
                    fill="#333333"></path>
              </svg>
            </a><a href="#/login">
              <svg class="icon" width="35" height="24" viewBox="0 0 35 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M33.5661 3.75519C33.1736 2.27706 32.0169 1.11294 30.5484 0.717875C27.8865 0 17.2127 0 17.2127 0C17.2127 0 6.53893 0 3.877 0.717875C2.40843 1.113 1.25181 2.27706 0.859246 3.75519C0.145996 6.43438 0.145996 12.0243 0.145996 12.0243C0.145996 12.0243 0.145996 17.6141 0.859246 20.2933C1.25181 21.7714 2.40843 22.8871 3.877 23.2821C6.53893 24 17.2127 24 17.2127 24C17.2127 24 27.8864 24 30.5484 23.2821C32.0169 22.8871 33.1736 21.7714 33.5661 20.2933C34.2794 17.6141 34.2794 12.0243 34.2794 12.0243C34.2794 12.0243 34.2794 6.43438 33.5661 3.75519V3.75519ZM13.7217 17.0994V6.94906L22.6429 12.0244L13.7217 17.0994V17.0994Z"
                    fill="#333333"></path>
              </svg>
            </a></div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:50px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swipe: [
        "img/swipe1s.jpg",
        "img/swipe2s.jpg",
        "img/swipe4s.jpg",
        "img/swipe5s.jpg",
        "img/swipe6s.jpg"
      ],
      swipe1: [
          "img/hot1.png",
        "img/hot2.png",
        "img/hot3.png",
        "img/hot4.png",
        "img/hot5.png",
        "img/hot6.png",
        "img/hot7.png",
        "img/hot8.png",
        "img/hot9.png",
        "img/hot10.png",
        "img/hot11.png",
        "img/hot12.png",
        "img/hot13.png",
        "img/hot14.png",
      ],
      bannerSwiperOption: {
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      interval: {
        type: Number,
        default: 3000 // 每3秒切换一次图片
      },
      timer: "",
      timer1: "",
    }
  },
  mounted(){
      const e = this.$refs.scrollList1;
      this.timer = setInterval( () => {
            e.scrollLeft = e.scrollLeft + 1;
            e.scrollLeft >= e.scrollWidth - e.clientWidth && (e.scrollLeft = 0)
            if(e.scrollLeft >= (e.scrollWidth - e.clientWidth)){
              e.scrollLeft = 0
            }
          }, 30);

    const e2 = this.$refs.scrollList2;
    this.timer1 = setInterval( () => {
      e2.scrollLeft = e2.scrollLeft + 1;
      if(e2.scrollLeft >= (e2.scrollWidth - e2.clientWidth)){
        e2.scrollLeft = 0
      }
    }, 30);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },
  created() {

  }
}
</script>

<style scoped>
.product-item{
  width: 10rem
}

.product-item .boxify-image-wrapper{
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: .33333rem
}

.product-item .boxify-image-wrapper .product-customized-labels{
  position: absolute;
  right: 0;
  padding: .4rem;
  background-color: #e62978;
  border-bottom-left-radius: .46667rem;
  border-bottom-right-radius: 0;
  border-top-right-radius: .33333rem;
  color: #fff;
  font-size: .8rem
}

.product-item .boxify-image-wrapper .lazyautosizes{
  width: 100%;
  height: 10rem;
  border-radius: .66667rem;
  -o-object-fit: cover;
  object-fit: cover
}

.product-item .info-box{
  padding: .4rem
}

.product-item .info-box .title{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  font-size: .8rem;
  color: #333
}

.product-item .info-box .price-sale{
  padding-top: .26667rem;
  color: #f01e76;
  text-align: center
}

.product-item .info-box .no-max{
  color: #000
}

.product-item .info-box .price-crossed{
  text-decoration: line-through;
  color: #888;
  text-align: center
}
.item-scroll-list {
  padding-top: 1.1rem;
  width: 100%;
  overflow-x: scroll;
  display: flex;
  -moz-column-gap: .53333rem;
  column-gap: .53333rem;
  scroll-behavior: smooth;
  scrollbar-width: none;
}
.login-home-page {
  width: 100%;
  min-height: 100vh;
  text-align: left
}

.login-home-page .category-tag {
  display: flex;
  flex-direction: column;
  row-gap: .4rem;
  text-align: center;
  font-size: .7rem
}

.login-home-page .category-tag img {
  width: 100%
}

.login-home-page .content-container {
  padding: 1rem;
  box-sizing: border-box
}

.login-home-page a {
  color: #333
}
#footer-custom-padding {
  padding: .4rem
}

#footer-custom-padding .footer-grid-items {
  display: flex;
  text-align: center;
  word-break: break-word;
  flex-direction: column
}

#footer-custom-padding .footer-grid-items .footer-grid-item {
  flex-grow: 1;
  padding: .5rem .5rem
}

#footer-custom-padding .footer-grid-items .footer-grid-item .text-title {
  font-size: 1rem;
  margin-bottom: 1rem
}

#footer-custom-padding .footer-grid-items .footer-social-icon-wrapper {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  -moz-column-gap: .8rem;
  column-gap: .8rem
}

#footer-custom-padding .footer-grid-items .footer-social-icon-wrapper svg  {
  fill: #e62978
}
.img-scroller {
  display: flex;
  -moz-column-gap: .26667rem;
  column-gap: .26667rem;
  width: 100%;
  overflow-x: scroll
}

.img-scroller img {
  height: 10rem
}

.img-scroller .price-tag {
  display: block;
  text-align: left;
  padding: .3rem .5rem;
  font-weight: 700
}

</style>
